import React, { useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import { spacing, SpacingProps } from "@mui/system";
import styled from "@emotion/styled";
import {
  Button as MuiButton,
  Box as MuiBox,
  Switch as MuiSwitch,
  Typography as MuiTypography
} from "@mui/material";

const Box = styled(MuiBox)`
  display: flex;
  gap: 28px;
  justify-content: center;
`;

interface ToggleWithModalProps {
  staffDetails: any;

  open: boolean;

  handleToggle: () => void;
}

interface ButtonProps extends SpacingProps {
  component?: React.ElementType;
  to?: string;
  target?: string;
}

const Button = styled(MuiButton)<ButtonProps>(spacing);

const Switch = styled(MuiSwitch)(({ theme, checked }) => ({
  marginTop: "8px",
  "& .MuiSwitch-switchBase": {
    color: checked ? "#192F67" : "#FAFAFA", // Checked and unchecked colors
    "&.Mui-checked": {
      color: checked ? "#192F67" : "#FAFAFA" // Checked color
    }
  }
}));

const Typography = styled(MuiTypography)`
  color: var(--light-text-secondary, rgba(0, 0, 0, 0.6));
  font-feature-settings: "clig" off, "liga" off;
  font-family: "Montserrat", sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 12px;
  letter-spacing: 0.15px;
`;

const ToggleWithModal: React.FC<ToggleWithModalProps> = ({
  staffDetails = {},
  open = false,
  handleToggle = () => {}
}) => {
  return (
    <div>
      <Typography>Status</Typography>
      <Switch checked={open} onChange={handleToggle} color="primary" />
      {/* <Dialog open={open} onClose={handleToggle}>
        <DialogContent>
          <Typography>
            Are you sure want to? {isActive ? <>activate</> : <>deactivate</>}{" "}
            the <b>staff</b>?`
          </Typography>

          <Box display={"flex"} flexDirection={"row"}>
            <Button
              variant="contained"
              color="secondary"
              mt={4}
              className="blue_button"
              onClick={handleToggleYes}
            >
              {"Yes"}
            </Button>
            <Button
              variant="contained"
              color="secondary"
              mt={4}
              className="blue_button"
              onClick={handleToggleNo}
            >
              {"No"}
            </Button>
          </Box>
        </DialogContent>
      </Dialog> */}
    </div>
  );
};

export default ToggleWithModal;
